import Axios from "../config/axios-v1-config";

// ─────────────────────────────────────────────────────────────────────────────
// Módulos habilitados por empresa (microservice-users, `users/tenant-modules`).
//
// La plataforma enciende herramientas (hoy solo el Rutificador) operador por
// operador y comercio por comercio. El portal solo LEE los módulos de su propio
// tenant; los habilita el superadmin del sistema desde la plataforma.
// ─────────────────────────────────────────────────────────────────────────────

// El cliente compartido espera 60 s. Esta consulta decide si se muestra una
// entrada del menú y si se abre una pantalla: colgarla un minuto dejaría al
// usuario frente a un "Cargando…" eterno, así que corta antes y deja reintentar.
const TENANT_MODULES_TIMEOUT_MS = 10000;

/**
 * Módulos del tenant del usuario autenticado:
 * `{ tenantType: 'logistic'|'company'|null, tenantId: string|null, modules: string[] }`.
 *
 * El backend resuelve el tenant desde el claim firmado del JWT, así que NO
 * recibe ningún id: uno por parámetro abriría la puerta a leer otro tenant.
 *
 * Como getSidebarBranding, NO atrapa el error: el llamador (hooks/useTenantModules)
 * tiene que distinguir "falló" de "no tiene módulos" para fallar cerrado sin
 * envenenar su cache.
 */
export const getMyTenantModules = async () => {
  const response = await Axios.get("users/tenant-modules/me", {
    timeout: TENANT_MODULES_TIMEOUT_MS,
  });
  return response.data;
};
